import {apolloClientService} from "../../../services/apollo-client"

export const billingHistoryService = {
  gettingData: getBillingHistoryDetails,
  getPrepaidBillingHistoryDetails: getPrepaidBillingHistoryDetails,
  gettingDropdown: getDropdownpData,
};

async function getBillingHistoryDetails(
  endDate,
  accountID,
  startDate,
  refresh
){
  let payment = localStorage.getItem("payment");
  let APIquery =
    `{getBillPayHistory(input:{
    endDate:"` +
    endDate +
    `",
    startDate:"` +
    startDate +
    `",
    accountId:"` +
    accountID +
    `"}){financialBillHistory}}`;
    let headers={
      accountId: accountID,
    }
    return payment ? await apolloClientService.ApolloClientgqlsUsage(APIquery,headers,'network-only', {fieldName: "getBillPayHistory"}):
    await apolloClientService.ApolloClientgqlsUsage(APIquery,headers,refresh?'network-only':"network-only", refresh && {fieldName: "getBillPayHistory"});
}
async function getPrepaidBillingHistoryDetails(
  endDate,
  accountID,
  startDate,
  mode,
  refresh
){
  let payment = localStorage.getItem("payment");
  let APIquery =
    `{getBillPayHistoryPrepaid(input:{
    accountId:"` +
    accountID +
    `"
    startDate:"` +
    startDate +
    `",
    endDate:"` +
    endDate +
    `",
    mode:"` +
    mode +
    `"
  }){financialBillHistory}}`;
    let headers={
      accountId: accountID,
    }
    return payment ? await apolloClientService.ApolloClientgqlsUsage(APIquery,headers,'network-only', {fieldName: "getBillPayHistoryPrepaid"}):
    await apolloClientService.ApolloClientgqlsUsage(APIquery,headers,refresh?'network-only':"", refresh && {fieldName: "getBillPayHistoryPrepaid"});
}

function getDropdownpData(groupCode,languageCode) {
  let APIquery =
    `{  getDropdownData(input:{groupCode:"` +
    groupCode +
    `",languageCode:"`+languageCode+`"})
   }`;
  return apolloClientService.ApolloClientgqls(APIquery);
}

export default billingHistoryService;
